function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.987 0H4C1.803 0 0 1.803 0 4.013V12c0 2.197 1.803 4 4 4h7.987A4.021 4.021 0 0016 11.987V4.013A4.021 4.021 0 0011.987 0zm-1.841 8H8.635v4.952H6.73V8H5.714V5.968h.89v-.863c0-.813.406-2.095 2.12-2.095h1.562v1.688H9.18c-.178 0-.42.115-.42.508v.762h1.563L10.146 8z",
  fill: "#4886F7"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default SvgFacebook;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/facebook.svg
// module id = 1278
// module chunks = 10